import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
export const Referral = ({
  callingPerson,
  crm,
  referralTakenBy,
  referralSource,
  referralTakenOn,
  referringFacility
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, "Referral"), /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.alignItemsCenter]
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.width50, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.referralCallReceivedFrom}: `), callingPerson), /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.callTakenBy}: `), referralTakenBy), /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.referralSourceType}: `), referralSource)), /*#__PURE__*/React.createElement(View, {
  style: [styles.width50, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.referringFacility}: `), referringFacility), /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.communityRelationsManager}: `), crm), /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.referralDate}: `), referralTakenOn))));